import { Navigate, Outlet } from 'react-router-dom';

import { useAppSelector } from 'store/hooks/use-app';
import type { AppState } from 'store/store';
import { routes } from 'routes';

export const ProtectedRoute = () => {
	const token = localStorage.getItem('userToken');
	const user = useAppSelector((state: AppState) => state.userState);

	return token && user ? <Outlet /> : <Navigate to={routes.login.path} />;
};
